"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP712_DOMAIN_TYPE_DATA = exports.RelayCall = void 0;
var RelayCall;
(function (RelayCall) {
    RelayCall[RelayCall["Sponsored"] = 0] = "Sponsored";
    RelayCall[RelayCall["SponsoredCallERC2771"] = 1] = "SponsoredCallERC2771";
})(RelayCall = exports.RelayCall || (exports.RelayCall = {}));
exports.EIP712_DOMAIN_TYPE_DATA = {
    EIP712Domain: [
        { name: "name", type: "string" },
        { name: "version", type: "string" },
        { name: "chainId", type: "uint256" },
        { name: "verifyingContract", type: "address" },
    ],
};
